export default {"src":"/_next/static/media/Key.558f3f72.svg","height":16,"width":16};